import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { Isku } from "../../client/product/useProduct";
import { Heading6, Subtitle2 } from "../../components/Typography";
import { COLOR_GRAY, COLOR_WHITE, COLOR_YELLOW } from "../../constants/colors";

type InformationProps = {
  label: string;
  value: string;
};

type LabelProps = {
  selected: boolean;
};

const Labels = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;
`;

const Label = styled.h2<LabelProps>`
  ${Heading6}

  position: relative;
  color: ${COLOR_WHITE};
  cursor: pointer;

  ${(props) =>
    props.selected &&
    css`
      color: ${COLOR_YELLOW};
      &::after {
        content: "";
        width: 100%;
        height: 6px;
        border-bottom: 6px solid ${COLOR_YELLOW};
        border-radius: 10px;
        position: absolute;
        left: 0;
        bottom: -14px;
        z-index: 1;
      }
    `}
`;

const Divider = styled.div`
  width: 100%;
  height: 6px;
  border-bottom: 6px solid ${COLOR_GRAY};
  border-radius: 10px;
`;

const Description = styled.div`
  > {
    all: unset;
  }

  ${Subtitle2}

  width: 100%;
  color: ${COLOR_WHITE};
  min-height: 160px;

  @media (max-width: 768px) {
    min-height: 150px;
  }
`;

function InformationSection({ informations }: { informations: InformationProps[] }) {
  const [selectedInformationIndex, setSelectedInformationIndex] = useState(0);

  useEffect(() => {
    setSelectedInformationIndex(0);
  }, []);

  return (
    <>
      <Labels>
        {informations.map((information, index) => (
          <Label
            key={information.label}
            selected={index === selectedInformationIndex}
            onClick={() => setSelectedInformationIndex(index)}
          >
            {information.label}
          </Label>
        ))}
      </Labels>
      <Divider className="mb-4" />
      {informations.flatMap((information, index) => {
        if (selectedInformationIndex === index) {
          return <Description dangerouslySetInnerHTML={{ __html: informations[selectedInformationIndex].value }} />;
        }

        return [];
      })}
    </>
  );
}

export default InformationSection;
